import { watch } from 'vue';

const sixAmInMinutes = 6 * 60;
const sixPmInMinutes = 18 * 60;

/**
 * Updates time-based gradient attributes and offset values.
 */
export function useTimezoneGradientOffset(timezoneStore) {
  let rafId = null;

  watch(
    () => timezoneStore.currentTime,
    () => updateGradientOffset(),
    { immediate: true }
  );

  const startTimezoneClock = () => {
    timezoneStore.startClock();
  };

  function updateGradientOffset() {
    // Keep a single frame-loop alive even while #nav-bar is absent (the
    // academic planning tool renders none), so a modal opened there gets its
    // gradient offset immediately instead of at the next 20s clock tick.
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(updateGradientOffset);

    const gradient = document.querySelector('.gradient-container');
    const nav = document.querySelector('#nav-bar');
    // Course modal carries the gradient on the wrapper; every other modal carries it
    // on the container.
    const courseModalWrapper = document.querySelector(
      '.full-page-modal.is-course-modal .full-page-modal__container-wrapper'
    );
    const eventModal = courseModalWrapper || document.querySelector('.full-page-modal__container');
    // The event modal also drives the gradient on its close bar.
    const eventCloseContainer = document.querySelector(
      '.full-page-modal.is-event-modal .full-page-modal__close-container'
    );
    const time = timezoneStore.currentTime;

    if (!time) return;

    const totalMinutes = time.getHours() * 60 + time.getMinutes();
    const isDay = totalMinutes >= sixAmInMinutes && totalMinutes < sixPmInMinutes;
    const dayNightAttr = isDay ? 'data-day' : 'data-night';
    const removeAttr = isDay ? 'data-night' : 'data-day';

    if (nav && gradient) {
      gradient.setAttribute(dayNightAttr, '');
      gradient.removeAttribute(removeAttr);
      nav.setAttribute(dayNightAttr, '');
      nav.removeAttribute(removeAttr);

      let progress;
      if (isDay) {
        progress = totalMinutes - sixAmInMinutes;
      } else if (totalMinutes < sixAmInMinutes) {
        progress = totalMinutes + (24 * 60 - sixPmInMinutes);
      } else {
        progress = totalMinutes - sixPmInMinutes;
      }

      const offset = (progress / 720) * 100 - 50;
      gradient.style.setProperty('--gradient-offset', `${offset}%`);
      nav.style.setProperty('--gradient-offset', `${offset}%`);

      if (eventModal) {
        eventModal.style.setProperty('--gradient-offset', `${offset}%`);
      }

      if (eventCloseContainer) {
        eventCloseContainer.style.setProperty('--gradient-offset', `${offset}%`);
      }
    }
  }

  return {
    startTimezoneClock,
    updateGradientOffset,
  };
}
